module.exports = __webpack_public_path__ + "static/media/tech-image-four.84a60bbc.png";